import { render, staticRenderFns } from "./ShrineInfo.vue?vue&type=template&id=58f0a471&"
import script from "./ShrineInfo.vue?vue&type=script&lang=js&"
export * from "./ShrineInfo.vue?vue&type=script&lang=js&"
import style0 from "../styles/shrine-info.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports